module.exports = __webpack_public_path__ + "img/car_shina2_05.5b3e13e3.jpg";